<template>
	<section>
		<h2 class="onboarding-title">Mark the milestones</h2>
		<p class="onboarding-text lead">
			We already know your name, so let's celebrate you with timely nudges and
			check-ins.
		</p>
		<div class="form-group">
			<label class="form-label" for="onboarding-birthday">Birthday</label>
			<input
				id="onboarding-birthday"
				type="date"
				class="form-control"
				v-model="model" />
		</div>
		<div class="form-group">
			<label class="form-label" for="onboarding-gender">Birth gender</label>
			<select id="onboarding-gender" class="form-select" v-model="genderModel">
				<option disabled value="">Select gender</option>
				<option value="male">Male</option>
				<option value="female">Female</option>
			</select>
		</div>
		<p class="onboarding-hint">
			<i class="bi bi-stars"></i>
			We'll use this to surface tailored seasonal recommendations and mindful
			celebrations.
		</p>
	</section>
</template>

<script setup>
	import { computed } from "vue"

	const props = defineProps({
		modelValue: {
			type: String,
			default: "",
		},
		gender: {
			type: String,
			default: "",
		},
	})

	const emit = defineEmits(["update:modelValue", "update:gender"])

	const model = computed({
		get: () => props.modelValue ?? "",
		set: (value) => emit("update:modelValue", value),
	})

	const genderModel = computed({
		get: () => props.gender ?? "",
		set: (value) => emit("update:gender", value),
	})
</script>

<style scoped>
	.onboarding-hint {
		display: inline-flex;
		align-items: center;
		gap: 0.5rem;
		margin-top: 0.75rem;
		padding: 0.5rem 0.75rem;
		background: rgba(56, 189, 248, 0.15);
		color: #0369a1;
		border-radius: 12px;
		font-weight: 600;
	}

	.onboarding-hint i {
		font-size: 1.1rem;
	}
</style>
